<ish-account-profile
  *ngIf="user$ | async as user"
  [user]="user"
  [subscribedToNewsletter]="subscribedToNewsletter$ | async"
/>
